import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import HmEventRegistry from '../../model/HmEventRegistry';

class OrderReview extends PreLoginPage {

	constructor(props) {
		super(props);
		this.getUserId=this.getUserId.bind(this);
	}

	componentDidMount(){
		//console.warn("order ",this.props.reviewData)
	}

	componentWillMount(){
		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
		
	}


	getUserId(){
		if(this.props.reviewData.userId!=undefined){
			return(
				<div>
						<span id="review-billing-userid">{this.props.reviewData.userId}</span>
					<br/>
					</div>
				)
		}
	}

	getAddrss2(){
		let address2 = this.props.reviewData.city+" , "+this.props.reviewData.state+" , "+this.props.reviewData.zip;
		return address2;
	}
	
	render() {
		var me=this;
		if(this.props.reviewData){
			return (
				<div id="confirm-dialog" className="mdl-dialog">
			     
			      <div className="">
			        <table align="center" cellPadding="0" cellSpacing="0" className="container-for-gmail-android" width="100%" >
			        <tbody>
			          <tr>
			            <td align="center" valign="top" width="100%" className="content-padding billingReviewTop">
			              <center>
			                <table cellSpacing="0" cellPadding="0">
			                  <tbody>
			                    <tr>
			                      <td className="free-text">
			                        Please review the billing details below before proceeding to pay.
			                      </td>
			                    </tr>
			
			                    <tr>
			                      <td className="">
			                      	<div className="row">	
			                      		<div className="col-6">
			                      			 <div className="mini-block">
                                                <span className="header-sm">Billing Address</span><br/>
																								{/* {me.getUserId()} */}
                                                <span id="review-billing-name">{this.props.reviewData.fullName}</span><br/>
                                                <span id="review-address-1">{this.props.reviewData.address}</span><br/>
                                                <span id="review-address-2">{this.getAddrss2()}</span><br/>
                                                <span id="review-address-3">{this.props.reviewData.country}</span>
                                              </div>
			                      		</div>
			                      		<div className="col-6">
			                      			 <div className="mini-block">                                               
                                                <span className="header-sm">Email address</span><br/>
                                                <span id="review-email">{this.props.reviewData.email}</span>
                                              </div>
			                      		</div>
			                      	</div>
			                       
			                      </td>
			                    </tr>
			                  </tbody>
			                </table>
			              </center>
			            </td>
			          </tr>
			          <tr>
			            <td align="center" valign="top" width="100%" className="splitblock">
			              <center>
			                <table cellPadding="0" cellSpacing="0">
			                  <tbody>
			                    <tr>
			                      <td className="item-table">
			                        <table cellSpacing="0" cellPadding="0" width="100%">
			                          <tbody id="confirm-cart">
			                            <tr>
			                              <td className="title-dark" width="200">
			                                Item
			                              </td>
			                              <td className="title-dark table-pull-right" width="100">
			                                Validity
			                              </td>
			                              <td className="title-dark table-pull-right" width="100">
			                                Quantity
			                              </td>
			                              <td className="title-dark table-pull-right" width="70">                                
			                              </td>
			                              <td className="title-dark table-pull-right" width="100">
			                                Total
			                              </td>
			                            </tr>
			
			                            <tr className="item-template">
			                              <td className="item-col item bold4dcolor">
			                              	{this.props.reviewData.productName}
			                              </td>
			                              <td className="item-col validity table-pull-right">{this.props.reviewData.validity}</td>
			                              <td className="item-col quantity table-pull-right">1</td>
			                              <td className="item-col table-pull-right pt4">{this.props.reviewData.currency}</td>
			                              <td className="item-col price table-pull-right">{this.props.reviewData.price}</td>
			                            </tr>
			
			                            <tr>
			                               <td className="item-col"></td>
			                              <td className="item-col"></td>
			                              <td className="item-col quantity subtotal">
			                                <span className="total-space">Subtotal</span> <br/>
			                                <span className="total-space">GST</span>
			                                <br/>
			                                <span className="total-space bold4dcolor">Total</span>
			                              </td>
			                              <td className="item-col table-pull-right topbdr">
			                                <span className="total-space currency">{this.props.reviewData.currency}</span>
			                                <br/>
			                                <span className="total-space currency">{this.props.reviewData.currency}</span>
			                                <br/>
			                                <span className="total-space currency bold4dcolor">{this.props.reviewData.currency}</span>
			                                <br/>
			                              </td>
			                              <td className="item-col price table-pull-right topbdr">
			                                <span className="total-space transx4">{(this.props.reviewData.basePrice).toFixed(2)}</span> <br/> 
			                                <span className="total-space">{(this.props.reviewData.taxAmount).toFixed(2)}</span>
			                                <br/>
			                                <span className="total-space bold4dcolor">{(this.props.reviewData.totalAmount).toFixed(2)}</span>
			                              </td>
			                            </tr>
			                          </tbody>
			                        </table>
			                      </td>
			                    </tr>
			                  </tbody>
			                </table>
			              </center>
			            </td>
			          </tr>
			        </tbody>
			      </table>
			      </div>
			      <div className="mdl-dialog__actions clearfix">
			      	<button data-ga={this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+ "Proceed to pay"} type="button" className="submitButton pay float-right" onClick={this.props.proceedPay}>Proceed to Pay</button>
			        <button data-ga={this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+ "Edit Details"} type="button" className="submitButton go-back float-right" onClick={this.props.hideReviewModal}>Edit Details</button>			        
			      </div>
			    </div>
		);
	}else{
		return(
			<div>
				</div>
		)
	}
		}
}

export default OrderReview;


// WEBPACK FOOTER //
// ./src/views/purchase/OrderReview.js